import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { trackEvent, identifyNewUser } from "../utils/posthog";
import { useAuth } from "../contexts/AuthContext";

function RegistrationForm() {
  const { login } = useAuth();
  const [isRegistering, setIsRegistering] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const navigate = useNavigate();
  const handleRegistration = async (event) => {
    event.preventDefault();
    try {
      // Perform registration API call
      await axios.post("/api/register", {
        email,
        password,
        firstName,
        lastName,
      });
      identifyNewUser(email, { signup_source: "email_password" });
      trackEvent("user_signed_up", { login_type: "email" });
      toast.success("Registration successful! Please log in.");
      setIsRegistering(false); // Switch to login form
    } catch (error) {
      console.error("Registration failed:", error);
      toast.error(
        error.response?.data?.error || "An error occurred during registration.",
      );
    }
  };
  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      await login(email, password);
      trackEvent("user_logged_in", { login_type: "email" });
      toast.success("Login successful!");
      navigate("/dashboard"); // Redirect to the user's dashboard or any protected route
    } catch (error) {
      console.error("Login failed:", error);
      toast.error(
        error.response?.data?.error || "An error occurred during login.",
      );
    }
  };
  return (
    <div className="flex flex-col items-center">
      <form
        onSubmit={isRegistering ? handleRegistration : handleLogin}
        className="flex flex-col max-w-md w-full"
      >
        {isRegistering && (
          <>
            <div className="mb-4">
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-text"
              >
                First Name
              </label>
              <input
                id="firstName"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                className="mt-1 p-2 block w-full border border-tint rounded-md focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/30"
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="lastName"
                className="block text-sm font-medium text-text"
              >
                Last Name
              </label>
              <input
                id="lastName"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                className="mt-1 p-2 block w-full border border-tint rounded-md focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/30"
              />
            </div>
          </>
        )}
        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-text"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-1 p-2 block w-full border border-tint rounded-md focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/30"
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="password"
            className="block text-sm font-medium text-text"
          >
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mt-1 p-2 block w-full border border-tint rounded-md focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/30"
          />
        </div>
        <button
          type="submit"
          className="mt-4 bg-accent hover:bg-accentDark text-white font-semibold py-2 px-4 rounded-md transition-colors"
        >
          {isRegistering ? "Register" : "Log In"}
        </button>
      </form>
    </div>
  );
}

export default RegistrationForm;
